 
  
<div [innerHtml]="KisshtHtml"></div>

<iframe [src]="KisshtHtml" width="600" height="400" frameborder="0" allowfullscreen></iframe>
